module.exports = __webpack_public_path__ + "static/media/blue_img_a.2beff1d4.png";